
import React from 'react';
import { User, HelpCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface BottomNavigationProps {
  handleInviteUser: () => void;
}

const BottomNavigation = ({
  handleInviteUser
}: BottomNavigationProps) => {
  return (
    <div className="border-t border-gray-100 dark:border-[rgba(60,63,84,0.6)] pt-2">
      <div className="flex items-center px-6 py-2.5 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800/40 transition-colors duration-200" onClick={handleInviteUser}>
        <User className="w-5 h-5 text-gray-500 dark:text-gray-400" />
        <span className="ml-3 text-gray-600 dark:text-gray-400">+ Utilisateurs</span>
      </div>
      
      <div className="flex items-center px-6 py-2.5 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800/40 transition-colors duration-200" onClick={() => {
        // Handle help
        console.log("Help clicked");
      }}>
        <HelpCircle className="w-5 h-5 text-gray-500 dark:text-gray-400" />
        <span className="ml-3 text-gray-600 dark:text-gray-400">Aide et ressources</span>
      </div>
    </div>
  );
};

export default BottomNavigation;
